export enum SiteType {
    HUB = 1,
    WAREHOUSE = 2,
}

export const SITE_TYPE_OPTIONS = [
    { label: 'Warehouse', value: SiteType.WAREHOUSE },
    { label: 'Hub', value: SiteType.HUB },
];
